<template>

    <div class="flex flex-col items-stretch min-h-screen max-h-screen custo-bkg select-none">

        <navbar :network="station"></navbar>

        <div class="flex flex-1">
            <div class="flex items-stretch min-h-full min-w-full">
                <div class="flex-1 w-full bg-grey-darker text-white max-w-25rem relative flex-col overflow-y-scroll">
                    <div class="" style="max-height: calc(100% - 35px); overflow-y: scroll">
                        <!-- Make sure this is opened upon first visit -->
                        <div class="border-b border-black">
                            <div class="p-3 bg-black cursor-pointer" v-on:click="accordianToggle('chasers')">
                                <span class="text-lg">Chasers</span>

                                <span class="float-right pt-0">
                                    <i class="fa fa-plus" v-if="!sidebarSections.chasers"></i>
                                    <i class="fa fa-minus" v-if="sidebarSections.chasers"></i>
                                </span>
                            </div>
                            <div class="w-full" :class="{'h-auto': sidebarSections.chasers, 'h-none': !sidebarSections.chasers}">

                                <!-- Loading -->
                                <div class="py-10 text-center" v-if="loadingStatus.chasers">
                                    <pulse-loader color="white"></pulse-loader>
                                </div>

                                <!-- Chasers -->
                                <div class="mt-1 mb-1" v-if="!loadingStatus.chasers">

                                    <div class="w-full border-l-4 h-24 mb-1 bg-grey-darkest" :class="{'border-green': chaser.properties.stream_status, 'border-orange': !chaser.properties.stream_status}" v-for="chaser in rawData.chasers.features">

                                        <div class="p-2 relative">
                                            <div class="w-full pt-1">
                                                <span class="rounded bg-red uppercase px-2 py-1 text-xs font-bold mr-3" v-if="chaser.properties.stream_status">LIVE 2:04 hr</span>
                                                <span class="rounded bg-grey-dark uppercase px-2 py-1 text-xs font-bold mr-3" v-if="!chaser.properties.stream_status">Position</span>
                                                <span class="rounded bg-blue uppercase px-2 py-1 text-xs font-bold mr-3" v-if="chaser.properties.viewers !== null">{{ chaser.properties.viewers }}</span>
                                            </div>
                                            <div class="w-full mt-3">
                                                <span class="text-xl font-bold">{{ chaser.properties.name }}</span>
                                            </div>
                                            <div class="w-full mt-1">
                                                <div class="text-md font-thin text-grey-light" v-if="chaser.properties.location !== undefined && chaser.properties.location !== null">{{ chaser.properties.location }}</div>
                                                <div class="text-md font-thin text-grey-light" v-if="chaser.properties.location == undefined || chaser.properties.location == null  || chaser.properties.location == null">Location Unavailable</div>
                                            </div>

                                            <div class="absolute pin-b pin-r">
                                                <div class="px-2 py-2 clearfix flex flex-1 items-center">
                                                    <div class="rounded-full h-8 w-8 flex items-center justify-center bg-grey-darker mr-2 hover:bg-blue cursor-pointer" v-on:click="flyToChaser(chaser)">
                                                        <i class="fa fa-location"></i>
                                                    </div>
                                                    <div class="rounded-full h-8 w-8 flex items-center justify-center bg-grey-darker hover:bg-blue cursor-pointer" v-on:click="openChaserFeed(chaser.properties)">
                                                        <i class="fa fa-eye"></i>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div class="w-full h-24 mb-1 text-center flex justify-center items-center" v-if="rawData.chasers.features.length == 0">

                                        <p>Chasers are currently offline. Please check back later.</p>

                                    </div>

                                </div>
                            </div>
                        </div>

                        <div class="border-b border-black">
                            <div class="p-3 bg-black cursor-pointer" v-on:click="accordianToggle('alerts')">
                                <span class="text-lg">Alerts</span>

                                <span class="float-right pt-0">
                                    <i class="fa fa-plus" v-if="!sidebarSections.alerts"></i>
                                    <i class="fa fa-minus" v-if="sidebarSections.alerts"></i>
                                </span>
                            </div>
                            <div class="w-full bg-grey-darkest" :class="{'h-auto': sidebarSections.alerts, 'h-none': !sidebarSections.alerts}">
                                <div class="p-3">

                                    <div class="-my-2" v-if="layerSettings.alerts.master">    
                                        <input type="checkbox" id="severe" name="checkbox" v-on:click="checkOtherBoxesThatAre('severe')" v-model="layerSettings.alerts.severe" />
                                        <label for="severe"><span></span>Severe</label>

                                        <input type="checkbox" id="tropical" name="checkbox" v-on:click="checkOtherBoxesThatAre('tropical')" v-model="layerSettings.alerts.tropical" />
                                        <label for="tropical"><span></span>Tropical</label>

                                        <input type="checkbox" id="winter" name="checkbox" v-on:click="checkOtherBoxesThatAre('winter')" v-model="layerSettings.alerts.winter" />
                                        <label for="winter"><span></span>Winter</label>
                                        
                                        <input type="checkbox" id="temperature" name="checkbox" v-on:click="checkOtherBoxesThatAre('temperature')" v-model="layerSettings.alerts.temperature" />
                                        <label for="temperature"><span></span>Temperature</label>

                                        <input type="checkbox" id="flood" name="checkbox" v-on:click="checkOtherBoxesThatAre('flood')" v-model="layerSettings.alerts.flood" />
                                        <label for="flood"><span></span>Flood</label>

                                        <input type="checkbox" id="other" name="checkbox" v-on:click="checkOtherBoxesThatAre('other')" v-model="layerSettings.alerts.other" />
                                        <label for="other"><span></span>Other</label>

                                    </div>
                                    <div class="sidebar-options-selector mt-5 bg-grey-darker" v-if="layerSettings.alerts.other">

                                        <div v-for="(alertCategory, index) in alertCategories">
                                            <input type="checkbox" :id="alertCategory.identifier" name="checkbox" v-model="alertCategories[index].checked" v-on:click="refreshAlerts()" />
                                            <label :for="alertCategory.identifier"><span></span>{{ alertCategory.alert }}</label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="border-b border-black">
                            <div class="p-3 bg-black cursor-pointer" v-on:click="accordianToggle('stormReports')">
                                <span class="text-lg">
                                    <i class="fa fa-lock text-sm mr-1" v-if="!userPremium"></i>
                                    Storm Reports
                                </span>

                                <span class="float-right pt-0">
                                    <i class="fa fa-plus" v-if="!sidebarSections.stormReports"></i>
                                    <i class="fa fa-minus" v-if="sidebarSections.stormReports"></i>
                                </span>
                            </div>
                            <div class="w-full bg-grey-darkest" :class="{'h-auto': sidebarSections.stormReports, 'h-none': !sidebarSections.stormReports}">

                                <div class="p-3">

                                    <div class="-my-2">
                                        <div v-for="(item, index) in layerSettings.lsrs">
                                            <input type="checkbox" :id="index" name="checkbox" v-model="item.active" @change="lsrToggle(index)" />
                                            <label :for="index"><span></span>{{ item.display }}</label>
                                        </div>
                                    </div>

                                </div>

                                <!-- Beginning -->
                                <!-- Loading -->
                                <div class="py-10 text-center" v-if="false && userPremium !== false">
                                    <pulse-loader color="white"></pulse-loader>
                                </div>

                                <!-- Chasers -->
                                <div class="mt-1 mb-1 bg-grey-darkest" v-for="report in rawData.reports">

                                    <div class="p-3">

                                        <div class="p-2 relative">
                                            <div class="w-full pt-1">
                                                {{ report.properties.remark }}
                                            </div>


                                        </div>

                                    </div>

                                </div>

                                <!-- END -->
                                <div class="bg-grey-darkest" v-if="!userPremium">
                                    <div class="p-10 text-center">
                                        Whoops! You must have a premium account to access these features.
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="border-b border-black">
                            <div class="p-3 bg-black cursor-pointer" v-on:click="accordianToggle('layers')">
                                <span class="text-lg">Layers</span>

                                <span class="float-right pt-0">
                                    <i class="fa fa-plus" v-if="!sidebarSections.layers"></i>
                                    <i class="fa fa-minus" v-if="sidebarSections.layers"></i>
                                </span>
                            </div>
                            <div class="w-full bg-grey-darkest" :class="{'h-auto': sidebarSections.layers, 'h-none': !sidebarSections.layers}">
                                <div class="p-4">
                                    <div class="-my-2">
                                        <input type="checkbox" id="lsrs" name="checkbox" checked v-on:click="settingsToggled('lsr')"/>
                                        <label for="lsrs" class="text-white"><span></span>Local Storm Reports</label>
                                        <input type="checkbox" id="alerts" name="checkbox" checked v-on:click="settingsToggled('alerts')"/>
                                        <label for="alerts" class="text-white"><span></span>Alerts</label>
                                        <input type="checkbox" id="radar" name="checkbox" checked v-on:click="settingsToggled('radar')"/>
                                        <label for="radar" class="text-white"><span></span>Radar</label>
                                        <input type="checkbox" id="lightning" name="checkbox" checked v-on:click="settingsToggled('lightning')"/>
                                        <label for="lightning" class="text-white"><span></span>Lightning</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="absolute pin-b pin-r w-100 mb-0 w-full">
                            <!-- <div>
                                <Adsense
                                    data-ad-client="ca-pub-7579317533194660"
                                    data-ad-slot="9754305599"
                                    data-ad-format="auto"
                                    data-full-width-responsive="true">
                                </Adsense>
                            </div> -->

                            <div class="bg-black p-2 clearfix flex flex-1 items-center">
                                <span class="w-4/5 text-sm uppercase">last update timestamp</span>
                                <span class="w-1/5 text-sm uppercase text-right cursor-pointer" v-on:click="toggleModal('mapSettingsModal')"><i class="fa fa-cog text-lg"></i></span>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="flex-1 text-white relative">
                    <div id="map" class="absolute"></div>
                </div>
            </div>
        </div>


        <map-settings-modal></map-settings-modal>

        <vue-draggable-resizable class="bg-black text-white" :w="videoPlayerDiv.dragWidth" :h="videoPlayerDiv.dragHeight" :x="videoPlayerDiv.dragX" :y="videoPlayerDiv.dragY" @dragging="onDrag" @resizing="onResize" :parent="true" :handles="['br']" axis="both" :min-width="500" :lock-aspect-ratio="true" v-if="popups.showVideo">
            <div slot="br">
                <i class="fas fa-caret-right"></i>
            </div>
            <div class="w-full py-2 px-4 cursor-move relative">
                <span class="text-xl">{{ popups.selectedChaser.name }} &middot; {{ popups.selectedChaser.location }}</span>
                <div class="absolute pin-r pin-t mr-2 text-2xl">
                    <i class="fa fa-times mt-2" v-on:click="closeModal('video')"></i>
                </div>
            </div>
            <div class="w-full">
                <div class="embed-responsive embed-responsive-16by9">
                    <StreamPlayer :streamId="popups.selectedChaser.stream_id" :ads="false" class="embed-responsive-item" />
                </div>
            </div>
        </vue-draggable-resizable>

    </div>
</template>

<script>

    import { EventBus } from '@/events'
    import * as Config from '@/config'
    import * as mapboxgl from 'mapbox-gl'
    import moment from 'moment'

    import Modal from '@/components/Modal'
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
    import MapSettings from '@/components/Modals/MapSettings'
    import Navbar from '@/components/Navbar'

    import VueDraggableResizable from 'vue-draggable-resizable'
    import StreamPlayer from '@/components/Modules/StreamPlayer'


    export default {
        name: 'Map',
        data() {
            return {
                map: null,
                radarData: null,
                loadingStatus: {
                    chasers: true,
                    radar: true,
                    alerts: true,
                },
                rawData: {
                    reports: [],
                    chasers: [],
                },
                loading: true,
                activePlan: null,
                sidebarSections: {
                    chasers: true,
                    alerts: false,
                    stormReports: false,
                    layers: false,
                },
                lastUpdate: null,

                // Temp set premium status
                userPremium: true,
                layersActive: {
                    lsrs: true,
                    alerts: true,
                    lightning: true,
                    radar: true,
                },
                videoPlayerDiv: {
                    dragWidth: 650,
                    dragHeight: 405,
                    dragX: 413,
                    dragY: 70
                },
                chatDiv: {
                    dragWidth: 350,
                    dragHeight: 405,
                    dragX: 470,
                    dragY: 150
                },
                popups: {
                    showVideo: false,
                    showChat: false,
                    selectedChaser: null,
                },
                layerSettings: {
                    alerts: {
                        master: true,
                        severe: true,
                        tropical: false,
                        winter: false,
                        temperature: false,
                        flood: false,
                        other: false,
                    },
                    lsrs: {
                        snow: {
                            active: true,
                            display: 'Snow'
                        },
                        rain: {
                            active: true,
                            display: 'Rain'
                        },
                        tornado: {
                            active: true,
                            display: 'Tornado'
                        },
                        flood: {
                            active: true,
                            display: 'Flood'
                        },
                        hail: {
                            active: true,
                            display: 'Hail'
                        },
                        'freezing-rain': {
                            active: true,
                            display: 'Freezing Rain'
                        },
                        sleet: {
                            active: true,
                            display: 'Sleet'
                        },
                        wind: {
                            active: true,
                            display: 'Wind'
                        },
                        'tstm-wind': {
                            active: true,
                            display: 'Thunderstorm Wind'
                        },
                    }
                },
                alertCategories: [
                    {
                        "alert": "Severe Thunderstorm Warning",
                        "identifier": "SVR",
                        "category": "severe",
                        "checked": true
                    },
                    {
                        "alert": "Tornado Warning",
                        "identifier": "TOR",
                        "category": "severe",
                        "checked": true
                    },
                    {
                        "alert": "Avalanche Watch",
                        "identifier": "AVA",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Avalanche Warning",
                        "identifier": "AVW",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Coastal Flood Warning",
                        "identifier": "CFW",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Coastal Flood Watch",
                        "identifier": "CFA",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Coastal Flood Statement",
                        "identifier": "CFWS",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Extreme Wind Warning",
                        "identifier": "EWW",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Flash Flood Watch",
                        "identifier": "FFA",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Flash Flood Warning",
                        "identifier": "FFW",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Flood Warning",
                        "identifier": "FLW",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Fire Warning",
                        "identifier": "FRW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Red Flag Warning",
                        "identifier": "RFW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Radiological Hazard Warning",
                        "identifier": "RHW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Special Marine Warning",
                        "identifier": "SMW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Special Weather Statement",
                        "identifier": "SPS",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Severe Weather Statement",
                        "identifier": "SVS",
                        "category": "severe",
                        "checked": true
                    },
                    {
                        "alert": "Flash Flood Statement",
                        "identifier": "FFS",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Areal Flood Advisory",
                        "identifier": "AFLA",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Areal Flood Statement",
                        "identifier": "AFLS",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Marine Weather Statement",
                        "identifier": "MWS",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Volcano Warning",
                        "identifier": "VOW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Winter Storm Warning",
                        "identifier": "WSW",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Winter Storm Watch",
                        "identifier": "WSA",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Tsunami Watch",
                        "identifier": "TSA",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Tsunami Warning",
                        "identifier": "TSW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Tropical Storm Warning",
                        "identifier": "TRW",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Tropical Storm Watch",
                        "identifier": "TRA",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Tornado Watch",
                        "identifier": "TOA",
                        "category": "severe",
                        "checked": true
                    },
                    {
                        "alert": "Severe Thunderstorm watch",
                        "identifier": "SVA",
                        "category": "severe",
                        "checked": true
                    },
                    {
                        "alert": "Storm Surge Warning",
                        "identifier": "SSW",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Storm Surge Watch",
                        "identifier": "SSWATCH",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Hurricane Statement",
                        "identifier": "HLS",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Hurricane Warning",
                        "identifier": "HUW",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "Hurricane Watch",
                        "identifier": "HUA",
                        "category": "tropical",
                        "checked": false
                    },
                    {
                        "alert": "High Wind Warning",
                        "identifier": "HWW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "High Wind Watch",
                        "identifier": "HWA",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Dust Storm Warning",
                        "identifier": "DSW",
                        "category": "other",
                        "checked": false
                    },
                    {
                        "alert": "Coastal Flood Warning",
                        "identifier": "CFW",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Coastal Flood Watch",
                        "identifier": "CFA",
                        "category": "flood",
                        "checked": false
                    },
                    {
                        "alert": "Blizzard Warning",
                        "identifier": "BZW",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Ice Storm Warning",
                        "identifier": "ICW",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Ice Storm watch",
                        "identifier": "ICA",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Lake Effect Snow Watch",
                        "identifier": "LEA",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Lake Effect Snow Warning",
                        "identifier": "LEW",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Winter Weather Advisory",
                        "identifier": "WWA",
                        "category": "winter",
                        "checked": false
                    },
                    {
                        "alert": "Extreme Cold Warning",
                        "identifier": "ECW",
                        "category": "temperature",
                        "checked": false
                    },
                    {
                        "alert": "Wind Chill Watch",
                        "identifier": "WCA",
                        "category": "temperature",
                        "checked": false
                    },
                    {
                        "alert": "Wind Chill Warning",
                        "identifier": "WCW",
                        "category": "temperature",
                        "checked": false
                    },
                    {
                        "alert": "Excessive Heat Warning",
                        "identifier": "EHW",
                        "category": "temperature",
                        "checked": false
                    },
                    {
                        "alert": "Excessive Heat Watch",
                        "identifier": "EHA",
                        "category": "temperature",
                        "checked": false
                    },
                    {
                        "alert": "Heat Advisory",
                        "identifier": "HEA",
                        "category": "temperature",
                        "checked": false
                    },
                    {
                        "alert": "Freezing Rain Advisory",
                        "identifier": "ZRA",
                        "category": "winter",
                        "checked": false
                    }
                ],
                flyingModal: null,
                station: null,
            }
        },
        beforeMount() {
            if(window.location.hostname == 'localhost') {
                this.station = 'kake'
                return
            }
            this.station = window.location.hostname.split('.')[0]
        },
        mounted() {
            console.log(this.station)
            var self = this;
            setTimeout(function() {
                self.initializeMap()
                self.addProductsToMap()
            }, 200);
        },
        components: {
            'modal': Modal,
            PulseLoader,
            'map-settings-modal': MapSettings,
            Navbar,
            VueDraggableResizable,
            StreamPlayer,
        },
        methods: {
            initializeMap() {
                this.$store.state.map = new mapboxgl.Map({
                    container: 'map',
                    style: this.$MapHelpers.determineMapStyle(),
                    center: [-72.58283971246843, 42.09636423291184],
                    zoom: 4,
                });
            },
            onResize: function (x, y, width, height) {
                this.x = x
                this.y = y
                this.width = width
                this.height = height
            },
            onDrag: function (x, y) {
                this.x = x
                this.y = y
            },
            addProductsToMap() {
                var _this = this;
                this.$store.state.map.on('style.load', function() {
                    // disable map rightclick
                    _this.$store.state.map.dragRotate.disable();
                    _this.$store.state.map.touchZoomRotate.disableRotation();

                    _this.addRequiredIcons()
                    _this.loadDataForProduct()
                    _this.addChasersToMap()
                    _this.addGeoJson()
                    _this.addLsrs()
                    _this.addAlertsToMap()
                    _this.addLightningToMap()
                    // _this.addRadarImageTypeTwo()

                    _this.$store.state.map.on('data', function(e) {
                        if (e.dataType === 'source') {
                            for (var x in _this.loadingStatus) {
                                if(x == e.sourceId) {
                                    _this.loadingStatus[x] = false
                                }
                            }
                        }
                    })

                    
                });

            },
            addRequiredIcons() {
                var _this = this
                this.$store.state.map.loadImage(require('@/assets/images/icons/snow-accumulation.png'), function(error, image) {
                    _this.$store.state.map.addImage('snow-accumulation', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/rain-accumulation.png'), function(error, image) {
                    _this.$store.state.map.addImage('rain-accumulation', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/tornado.png'), function(error, image) {
                    _this.$store.state.map.addImage('tornado', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/flood.png'), function(error, image) {
                    _this.$store.state.map.addImage('flood', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/hail.png'), function(error, image) {
                    _this.$store.state.map.addImage('hail', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/wind-tstm.png'), function(error, image) {
                    _this.$store.state.map.addImage('wind-tstm', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/ice.png'), function(error, image) {
                    _this.$store.state.map.addImage('ice', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/sleet.png'), function(error, image) {
                    _this.$store.state.map.addImage('sleet', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/direction-in-position.png'), function(error, image) {
                    _this.$store.state.map.addImage('direction-in-position', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/direction-streaming.png'), function(error, image) {
                    _this.$store.state.map.addImage('direction-streaming', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/stationary-in-position.png'), function(error, image) {
                    _this.$store.state.map.addImage('stationary-in-position', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/stationary-streaming.png'), function(error, image) {
                    _this.$store.state.map.addImage('stationary-streaming', image);
                });
                this.$store.state.map.loadImage(require('@/assets/images/icons/lightning.png'), function(error, image) {
                    _this.$store.state.map.addImage('lightning', image);
                });


            },
            loadDataForProduct() {
                var _this = this;
                this.$http.get("https://weather-tiling-api.wxdata.io/data/current/1/current").then((response) => {
                    this.$set(this, 'radarData', response.data);
                    _this.addLayerToMap()
                });
            },
            addLayerToMap() {

                let isSmoothedDataEnabled = this.$MapHelpers.isRawDataEnabled()

                var source =  "https://tiles.wxdata.io/tileserver/radar/" + this.radarData.identifier + "/{z}/{x}/{y}.png"

                if(isSmoothedDataEnabled == false) {
                    source = "https://tiles.wxdata.io/tileserver/radar/" + this.radarData.identifier + "_smoothed/{z}/{x}/{y}.png"
                }

                this.$store.state.map.addLayer({
                   'id': 'radar',
                   'type': 'raster',
                   'source': {
                       'type': 'raster',
                       'tiles': [
                           source
                       ],
                       'tileSize': 256,
                   },
                   'paint': {
                       'raster-opacity': 0.6,
                   }
               }, this.$MapHelpers.determineLayerPlacement(this.$store.state.map, 'radar'));
               this.$store.state.map.on('click', 'place_other', function(e) {
                   console.log(e)
               });
           },
           addChasersToMap() {

                var _this = this
                this.$http.get(Config.apiPath + "/api/v1/networks/" + this.station + "/chasers?geojson=true").then((response) => {

                    _this.rawData.chasers = response.data
                    _this.loadingStatus.chasers = false

                    _this.$store.state.map.addSource('chasers', {
                        'type': 'geojson',
                        'data': response.data
                    });

                    _this.$store.state.map.addLayer({
                        'id': 'online-chasers',
                        'type': 'symbol',
                        'source': 'chasers',
                        'layout': {
                            'icon-image': 'stationary-streaming',
                            'icon-size': 0.25,
                            'icon-allow-overlap': true,
                            'icon-rotate': {
                                type: 'identity',
                                property: 'heading',
                                default: 0
                            }
                        },
                        'filter': [
                            'all',
                            ['==', 'stream_status', true],
                        ]
                        
                    })

                    _this.$store.state.map.addLayer({
                        'id': 'offline-chasers',
                        'type': 'symbol',
                        'source': 'chasers',
                        'layout': {
                            'icon-image': 'stationary-in-position',
                            'icon-size': 0.25,
                            'icon-allow-overlap': true,
                            'icon-rotate': {
                                type: 'identity',
                                property: 'heading',
                                default: 0
                            }
                        },
                        'filter': [
                            'all',
                            ['==', 'stream_status', false],
                        ]
                    })
                    
                    let layers = ['online-chasers', 'offline-chasers']
                    layers.forEach(function(layer) {
                        _this.$store.state.map.on('mouseover', layer, function(e) {
    
                            
                            var chasers = _this.$store.state.map.queryRenderedFeatures(e.point, { layers: layers });
                            console.log(chasers)
          
                            var className = 'chaser-popup'
                            var textColorPrimary = 'text-black'
                            var textColorSecondary = 'text-grey-darker'

                            if(_this.$MapHelpers.isDarkModeEnabled()) {
                                className += ' chaser-darkmode'
                                textColorPrimary = 'text-white'
                                textColorSecondary = 'text-grey'
                            }

                            if(chasers.length == 1) {
                                _this.chaserTooltip = new mapboxgl.Popup({ offset: 18, className: className })
                                    .setLngLat(chasers[0].geometry.coordinates)
                                    .setHTML(
                                        '<div class="header p-3"><h2>' + chasers[0].properties.name + '<h2></div>' +
                                        '<div class="p-3">' +
                                        '<ul class="list-reset text-sm">' +
                                        '<li><span class="uppercase ' + textColorSecondary + ' text-xs">Location</span> <br/> <strong class="' + textColorPrimary + '">' + chasers[0].properties.location + '</strong></li>' +
                                        '<li class="pt-2"><span class="uppercase ' + textColorSecondary + ' text-xs">Report Time</span> <br/> <strong class="' + textColorPrimary + '">' + moment.utc(chasers[0].properties.gps_update).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(chasers[0].properties.gps_update).fromNow() + ')</strong></li>' +
                                        '</ul></div>'
                                    )
                                    .addTo(_this.$store.state.map);
                            } else {
                                _this.chaserTooltip = null
                                new mapboxgl.Popup({ offset: 18, className: className })
                                    .setLngLat(chasers[0].geometry.coordinates)
                                    .setHTML(
                                        '<div class="header p-3"><h2>Chasers<h2></div>' +
                                        '<div class="p-3">' +
                                        '<ul class="list-reset text-sm">' +
                                        _this.parseChasersToInfo(chasers) +
                                        '</ul></div>'
                                    )
                                    .addTo(_this.$store.state.map);
                            }
                            
                        })

                        _this.$store.state.map.on('mouseout', layer, function(e) {
                            if(_this.chaserTooltip !== null) {
                                _this.chaserTooltip.remove()
                            }
                        })
                    })

                   

                });

           },

            parseChasersToInfo(chasers) {
                var className = 'chaser-popup'
                var textColorPrimary = 'text-black'
                var textColorSecondary = 'text-grey-darker'

                if(this.$MapHelpers.isDarkModeEnabled()) {
                    className += ' chaser-darkmode'
                    textColorPrimary = 'text-white'
                    textColorSecondary = 'text-grey'
                }

                var res = "";

                chasers.forEach(function(chaser) {
                    res += '<div><strong class="' + textColorPrimary + '">' + chaser.properties.name + '</strong> ' +
                            '<span class="' + textColorPrimary + ' float-right">' + moment.utc(chaser.properties.gps_update).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(chaser.properties.gps_update).fromNow() + ')</span></div>'
                })

                return res

            },

            addAlertsToMap() {
                this.$store.state.map.addLayer({
                    'id': 'alerts',
                    'type': 'fill',
                    'source': {
                        'type': 'geojson',
                        'data': 'https://site.wxdata.io/api/alerts?geojson=true',
                        'tolerance': 1
                    },
                    'paint': {
                        'fill-color': { type: 'identity', property: 'fill' },
                        'fill-opacity': 0.6,
                    }
                }, this.$MapHelpers.determineLayerPlacement(this.$store.state.map, 'alerts'));

                this.$store.state.map.on('click', 'alerts', this.alertClickListener);

            },

            removeAlertsFromMap() {
                this.$store.state.map.removeLayer('alerts')
                this.$store.state.map.removeSource('alerts')
                this.$store.state.map.off('click', 'alerts', this.alertClickListener);
            },

            isLoading() {
                var loading = false

                for (var x in this.loadingStatus) {

                    if(this.loadingStatus[x] == true) {
                        console.log(this.loadingStatus[x])
                        loading = true
                    }

                }
                return loading

            },
            alertClickListener(e) {
                console.log(e.features)

                var className = 'lsr-popup'
                var textColorPrimary = 'text-black'
                var textColorSecondary = 'text-grey-darker'

                if(this.$MapHelpers.isDarkModeEnabled()) {
                    className += ' lsr-darkmode'
                    textColorPrimary = 'text-white'
                    textColorSecondary = 'text-grey'
                }

                var htmlContent = "";

                if(e.features.length == 1) {
                    var alertDetails = JSON.parse(e.features[0].properties.meta)
                    htmlContent += '<div class="header p-3" style="border-left: 6px solid ' + e.features[0].properties.fill + '"><h2>' + alertDetails.event + '</h2></div>'
                    htmlContent += '<div class="p-3"><ul class="list-reset ' + textColorPrimary + '"><li><strong class="' + textColorPrimary + '">Severity</strong>: ' + alertDetails.parameters.severity + '</li><li><strong class="' + textColorPrimary + '">Certainty</strong>: ' + alertDetails.parameters.certainty + '</li><li><strong class="' + textColorPrimary + '">Urgency</strong>: ' + alertDetails.parameters.urgency + '</li><li><strong class="' + textColorPrimary + '">Expires</strong>: ' +  moment.utc(alertDetails.expires).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(alertDetails.expires).fromNow() + ')</li></ul><div class="' + textColorPrimary + ' pt-2">'
                    htmlContent += alertDetails.description + '</div></div>'
                }
                
                if(e.features.length > 1) {
                    htmlContent += '<div class="header p-3"><h2>Multiple Alerts</h2></div>'
                    textColorPrimary = 'text-white'
                    
                    e.features.forEach(function(feature) {
                        var alertDetails = JSON.parse(feature.properties.meta)
                        
                        // htmlContent += ''
                        // htmlContent += '<div class="wrap-collabsible"><div class="m-2 p-3 bg-black text-white relative" style="border-left: 6px solid ' + feature.properties.fill + '"><h3>' + alertDetails.event + '</h3><input id="collapsible" class="toggle" style="display: none;" type="checkbox"><label for="collapsible" class="pin-r pin-t absolute bg-blue-dark text-white px-2 py-2 mt-2 mr-2 rounded outline-none block">More Info</label></div><div class="collapsible-content"><div class="content-inner"><p>QUnit is by calling one of the object that are embedded in JavaScript, and faster JavaScript program could also used withits elegant, well documented, and functional programming using JS, HTML pages Modernizr is a popular browsers withoutplug-ins. Test-Driven Development.</p></div></div>'
                        htmlContent += '<div class="wrap-collabsible bg-black text-white m-2" style="border-left: 6px solid ' + feature.properties.fill + '"><input id="' + alertDetails.id + '" class="toggle" type="checkbox"><label for="' + alertDetails.id + '" class="relative p-3 lbl-toggle" style="margin: 0;"><h3>' + alertDetails.event + '</h3></label>'
                        htmlContent += '<div class="collapsible-content"><div class="content-inner"><div class="px-3"><ul class="list-reset ' + textColorPrimary + '"><li><strong class="' + textColorPrimary + '">Severity</strong>: ' + alertDetails.parameters.severity + '</li><li><strong class="' + textColorPrimary + '">Certainty</strong>: ' + alertDetails.parameters.certainty + '</li><li><strong class="' + textColorPrimary + '">Urgency</strong>: ' + alertDetails.parameters.urgency + '</li><li><strong class="' + textColorPrimary + '">Expires</strong>: ' +  moment.utc(alertDetails.expires).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(alertDetails.expires).fromNow() + ')</li></ul></div><p class="px-3 py-3 ' + textColorPrimary + '">' + alertDetails.description + '</p></div></div></div>'
                   })

                    // htmlContent += '<div class="p-3"><ul class="list-reset"><li><strong>Severity</strong>: ' + alertDetails.parameters.severity + '</li><li><strong>Certainty</strong>: ' + alertDetails.parameters.certainty + '</li><li><strong>Urgency</strong>: ' + alertDetails.parameters.urgency + '</li><li><strong>Expires</strong>: ' +  moment.utc(alertDetails.expires).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(alertDetails.expires).fromNow() + ')</li></ul>'
                    // htmlContent += alertDetails.description + '</div>'
                }

                new mapboxgl.Popup({ className: className })
                    .setLngLat(e.lngLat)
                    .setHTML(htmlContent)
                    .addTo(this.$store.state.map);
            },

            addGeoJson() {
                var _this = this
                this.$http.get("https://api.aerisapi.com/convective/outlook/search?filter=cat&format=geojson&from=today&client_id=qmuqsyqtoRQEpBTzFHHjJ&client_secret=wGRV0EQzq13FRr3C57hxyWeAOLlLhBuV9CAzIXtd").then((response) => {
                    response.data.features.forEach(function(result) {
                        var thing = _this.determineColorForOutlook(result.properties['details']['risk']['type'])
                        _this.$store.state.map.addLayer({
                                'id': 'day1-' + result.properties['details']['risk']['type'],
                                'type': 'fill',
                                'source': {
                                    'type': 'geojson',
                                    'data': result
                                },
                                'layout': {},
                                'paint': {
                                    'fill-color': thing,
                                    'fill-opacity': 0.5
                                }
                            }, _this.$MapHelpers.determineLayerPlacement(_this.$store.state.map, 'spc'))
                        console.log(result)
                    })

                });
            },

            addLsrs() {
                if(this.userPremium) {

                    var _this = this;
                    this.$http.get("https://site.wxdata.io/api/lsrs?start=6 hours ago&end=now&geojson=true").then((response) => {

                    _this.$store.state.map.addSource('lsrs', {
                    'type': 'geojson',
                    'data': response.data
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-snow',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'snow-accumulation',
                    'text-field': '{magnitude}',
                    'text-anchor': 'center',
                    'text-size': 14,
                    'text-letter-spacing': 0.05,
                    'text-offset': [0.75, 0]
                    },
                    'paint': {
                    'text-color': '#000',
                    'text-halo-width': .25,
                    'text-halo-color': '#000',

                    },
                    'filter': ['==', 'type_id', 'S']
                    })

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-rain',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'rain-accumulation',
                    'text-field': '{magnitude}',
                    'text-anchor': 'center',
                    'text-size': 14,
                    'text-letter-spacing': 0.05,
                    'text-offset': [0.75, 0]
                    },
                    'paint': {
                    'text-color': '#000',
                    'text-halo-width': .25,
                    'text-halo-color': '#000',

                    },
                    'filter': ['==', 'type_id', 'R']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-tornado',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'tornado',
                    },
                    'filter': ['==', 'type_id', 'T']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-flood',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'flood',
                    },
                    'filter': ['==', 'type_id', 'F']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-hail',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'hail',
                    },
                    'filter': ['==', 'type_id', 'H']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-freezing-rain',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'ice',
                    },
                    'filter': ['==', 'type_id', '5']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-sleet',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'sleet',
                    },
                    'filter': ['==', 'type_id', 's']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-wind',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'wind-tstm',
                    },
                    'filter': ['==', 'type_id', 'O']
                    });

                    _this.$store.state.map.addLayer({
                    'id': 'lsrs-tstm-wind',
                    'type': 'symbol',
                    'source': 'lsrs',
                    'layout': {
                    'icon-image': 'wind-tstm',
                    },
                    'filter': ['==', 'type_id', 'D']
                    });

                    _this.$store.state.map.on('click', function(e) {
                        var layers = ['lsrs-snow', 'lsrs-rain', 'lsrs-tornado', 'lsrs-flood', 'lsrs-hail', 'lsrs-freezing-rain', 'lsrs-sleet', 'lsrs-wind', 'lsrs-tstm-wind']

                        // make sure layers exist
                        var status = false;
                        var x;
                        for (x in layers) {
                            if(typeof _this.$store.state.map.getLayer(layers[x]) !== 'undefined') {
                                status = true;
                            }
                        }

                        // if layers exist, get status
                        if(status == true) {
                            var pointFeatures = _this.$store.state.map.queryRenderedFeatures(e.point, { layers: ['lsrs-snow', 'lsrs-rain', 'lsrs-tornado', 'lsrs-flood', 'lsrs-hail', 'lsrs-freezing-rain', 'lsrs-sleet', 'lsrs-wind', 'lsrs-tstm-wind'] });
                            if(pointFeatures.length > 0) {
                                console.log(pointFeatures)

                                var className = 'lsr-popup'
                                var textColorPrimary = 'text-black'
                                var textColorSecondary = 'text-grey-darker'
                                console.log(_this.$MapHelpers.isDarkModeEnabled())
                                if(_this.$MapHelpers.isDarkModeEnabled()) {
                                className += ' lsr-darkmode'
                                textColorPrimary = 'text-white'
                                textColorSecondary = 'text-grey'
                                }

                                console.log(pointFeatures[0].properties.magnitude)
                                new mapboxgl.Popup({ offset: 18, className: className })
                                .setLngLat(pointFeatures[0].geometry.coordinates)
                                .setHTML(
                                    '<div class="header p-3"><h2>Local Storm Report<h2></div>' +
                                    '<div class="p-3">' +
                                    '<ul class="list-reset text-sm">' +
                                    '<li><span class="uppercase ' + textColorSecondary + ' text-xs">Location</span> <br/> <strong class="' + textColorPrimary + '">' + pointFeatures[0].properties.city + ", " + pointFeatures[0].properties.state + '</strong></li>' +
                                    '<li class="pt-2"><span class="uppercase ' + textColorSecondary + ' text-xs">Report Type</span> <br/> <strong class="' + textColorPrimary + '">' + pointFeatures[0].properties.type + '</strong></li>' +
                                    '<li class="pt-2 ' + ((pointFeatures[0].properties.magnitude == null || pointFeatures[0].properties.magnitude == "null") ? 'hidden' : '') + '"><span class="uppercase ' + textColorSecondary + ' text-xs">Magnitude</span> <br/> <strong class="' + textColorPrimary + '">' + pointFeatures[0].properties.magnitude + '</strong></li>' +
                                    '<li class="pt-2 ' + ((pointFeatures[0].properties.remark == null || pointFeatures[0].properties.remark == "null") ? 'hidden' : '') + '"><span class="uppercase ' + textColorSecondary + ' text-xs">Comments</span> <br/> <strong class="' + textColorPrimary + '">' + pointFeatures[0].properties.remark + '</strong></li>' +
                                    '<li class="pt-2"><span class="uppercase ' + textColorSecondary + ' text-xs">Source</span> <br/> <strong class="' + textColorPrimary + '">' + pointFeatures[0].properties.source + '</strong></li>' +
                                    '<li class="pt-2"><span class="uppercase ' + textColorSecondary + ' text-xs">Report Time</span> <br/> <strong class="' + textColorPrimary + '">' + moment.utc(pointFeatures[0].properties.valid).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(pointFeatures[0].properties.valid).fromNow() + ')</strong></li>' +
                                    '</ul></div>'
                                )
                                .addTo(_this.$store.state.map);
                            }
                        }


                        })

                    })
                }
            },

           removeLsrs() {
               var layers = ['lsrs-snow', 'lsrs-rain', 'lsrs-tornado', 'lsrs-flood', 'lsrs-hail', 'lsrs-freezing-rain', 'lsrs-sleet', 'lsrs-wind', 'lsrs-tstm-wind']

               var x;
               for (x in layers) {
                   if(typeof this.$store.state.map.getLayer(layers[x]) !== 'undefined') {
                       this.$store.state.map.removeLayer(layers[x])
                   }
               }

               if(typeof this.$store.state.map.getSource('lsrs') !== 'undefined') {
                   this.$store.state.map.removeSource('lsrs')
               }
           },

           determineColorForOutlook(type) {
               if(type == 'general') {
                   return '#A3E8AC'
               }
               if(type == 'marginal') {
                   return '#46C05E'
               }
               if(type == 'slight') {
                   return '#F2FA3E'
               }
               if(type == 'enhanced') {
                   return '#E8B658'
               }
           },

            settingsToggled(setting) {

                if(setting == 'lsr') {
                    var current = this.layersActive.lsrs
                    if(current) {
                        this.removeLsrs()
                    } else {
                        this.addLsrs()
                    }
                    this.layersActive.lsrs = !current
                }

                if(setting == 'alerts') {
                    var current = this.layersActive.alerts
                    if(current) {
                        this.removeAlertsFromMap()
                    } else {
                        this.addAlertsToMap()
                    }
                    this.layersActive.alerts = !current
                }

                if(setting == 'lightning') {
                    var current = this.layersActive.lightning
                    if(current) {
                        this.removeLightningFromMap()
                    } else {
                        this.addLightningToMap()
                    }
                    this.layersActive.lightning = !current
                }

                if(setting == 'radar') {
                    var current = this.layersActive.radar
                    if(current) {
                        this.removeRadarFromMap()
                    } else {
                        this.loadDataForProduct()
                    }
                    this.layersActive.radar = !current
                }

            },

            removeLightningFromMap() {
                this.$store.state.map.removeLayer('lightning')
                this.$store.state.map.removeSource('lightning')
            },

            removeRadarFromMap() {
                this.$store.state.map.removeLayer('radar')
                this.$store.state.map.removeSource('radar')
            },

           addLightningToMap() {
               var _this = this
                this.$http.get("https://site.wxdata.io/api/lightning?start=1 minutes ago&end=now&geojson=true").then((response) => {

                    _this.$store.state.map.addSource('lightning', {
                        'type': 'geojson',
                        'data': response.data
                    });

                    _this.$store.state.map.addLayer({
                        'id': 'lightning',
                        'type': 'symbol',
                        'source': 'lightning',
                        'layout': {
                            'icon-allow-overlap': true,
                            'icon-image': 'lightning',
                        },
                    });
                })
           },


           // Toggle Modal
           toggleModal(id) {
                EventBus.$emit('toggle-modal:' + id);
            },

            accordianToggle(option) {
                this.sidebarSections[option] = !this.sidebarSections[option]
            },

            flyToChaser(chaser) {
                this.$store.state.map.flyTo({
                    center: chaser.geometry.coordinates,
                    zoom: 10
                })

                if(this.flyingModal !== null) {
                    this.flyingModal.remove()
                }

                var className = 'chaser-popup'
                var textColorPrimary = 'text-black'
                var textColorSecondary = 'text-grey-darker'

                if(this.$MapHelpers.isDarkModeEnabled()) {
                    className += ' chaser-darkmode'
                    textColorPrimary = 'text-white'
                    textColorSecondary = 'text-grey'
                }

                this.flyingModal = new mapboxgl.Popup({ offset: 18, className: className })
                    .setLngLat(chaser.geometry.coordinates)
                    .setHTML(
                        '<div class="header p-3"><h2>' + chaser.properties.name + '<h2></div>' +
                        '<div class="p-3">' +
                        '<ul class="list-reset text-sm">' +
                        '<li><span class="uppercase ' + textColorSecondary + ' text-xs">Location</span> <br/> <strong class="' + textColorPrimary + '">' + chaser.properties.location + '</strong></li>' +
                        '<li class="pt-2"><span class="uppercase ' + textColorSecondary + ' text-xs">Report Time</span> <br/> <strong class="' + textColorPrimary + '">' + moment.utc(chaser.properties.gps_update).local().format('MMMM D, Y h:mm A') + ' (' + moment.utc(chaser.properties.gps_update).fromNow() + ')</strong></li>' +
                        '</ul></div>'
                    )
                    .addTo(this.$store.state.map);
            },

            openChaserFeed(chaser) {
                this.popups.selectedChaser = chaser
                this.popups.showVideo = true
            },

            openChaserChat() {
                this.popups.showChat = true
            },

            closeModal(type) {
                if(type == 'video') {
                    this.popups.showVideo = false
                }
                if(type == 'chat') {
                    this.popups.showChat = false
                }
            },
            lsrToggle(index) {
                if(this.layerSettings.lsrs[index].active) { // make it visible
                    this.$store.state.map.setLayoutProperty('lsrs-' + index, 'visibility', 'visible')
                } else {    // make hidden
                    this.$store.state.map.setLayoutProperty('lsrs-' + index, 'visibility', 'none')
                }
            }

        },
    }

</script>

<style>
    .navbar-logo {
        max-height: 40px;
        width: auto;
    }
    .embed-responsive.embed-responsive-16by9 {
        padding-bottom: 56.25%;
    }
    .embed-responsive {
        position: relative;
        display: block;
        height: 0;
        padding: 0;
        overflow: hidden;
    }
    .embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
    #map {
        height: 100%;
        width:100%;
        flex:1;
    }
    .custo-bkg {
        background-color: #22292f;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23474747' fill-opacity='0.34'%3E%3Cpath opacity='.5' d='M96 95h4v1h-4v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4h-9v4h-1v-4H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15v-9H0v-1h15V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h9V0h1v15h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9h4v1h-4v9zm-1 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm9-10v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-10 0v-9h-9v9h9zm-9-10h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9zm10 0h9v-9h-9v9z'/%3E%3Cpath d='M6 5V0H5v5H0v1h5v94h1V6h94V5H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }

    .max-w-25rem {
        max-width: 25rem;
    }

    .custom-max-height {
        max-height: 100px;
        overflow: hidden;
    }

    .h-none {
        height: 0px;
        overflow: hidden;
    }


    /* lsr-popup */
    .lsr-popup {
        width: 400px;
        color: #000;
    }

    .lsr-popup .mapboxgl-popup-content {
        padding: 0px;
    }

    .lsr-popup .header {
        background-color: #22292f;
        height: auto;
        color: #fff;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
    }

    .lsr-darkmode .mapboxgl-popup-content{
        background-color: #3d4852;
    }

    .lsr-darkmode .mapboxgl-popup-tip {
        border-top-color: #3d4852;
    }

    .lsr-popup .mapboxgl-popup-close-button {
        font-size: 30px;
        margin-right: 12px;
        margin-top: 3px;
        color: #fff;
    }

    .lsr-darkmode .mapboxgl-popup-close-button:hover {
        background-color: transparent;
    }


    /* chaser popup */
    .chaser-popup {
        width: 400px;
        color: #000;
    }

    .chaser-popup .mapboxgl-popup-content {
        padding: 0px;
    }

    .chaser-popup .header {
        background-color: #22292f;
        color: #fff;
        border-top-right-radius: 3px;
        border-top-left-radius: 3px;
        height: auto;
    }

    .chaser-darkmode .mapboxgl-popup-content{
        background-color: #3d4852;
    }

    .chaser-darkmode .mapboxgl-popup-tip {
        border-top-color: #3d4852;
    }

    .chaser-popup .mapboxgl-popup-close-button {
        font-size: 30px;
        margin-right: 12px;
        margin-top: 3px;
        color: #fff;
    }

    .chaser-darkmode .mapboxgl-popup-close-button:hover {
        background-color: transparent;
    }




    /* custom buttons */
    input[type='checkbox'], input[type='radio'] {
        display:none;
    }
    input[type='checkbox'] + label {
        position: relative;
        display: flex;
        margin: 10px 0;
        font-weight: normal;
    }
    input[type='checkbox'] + label > ins {
        position: absolute;
        display: block;
        width: 100%;
        overflow: hidden;
        text-decoration: none;
    }
    input[type='checkbox'] + label > ins > i {
        position: absolute;
        bottom: 0;
        font-style: normal;
    }
    input[type='checkbox'] + label > span {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background: transparent;
        border: 2px solid #333;
        cursor: pointer;
    }
    input[type='checkbox'] + label > button {
        width:  auto;
        height: auto;
        text-align: right;
        float: right;
        right: 0;
        position: absolute;
        margin-top: -3px;
        top: 0;
    }
    input[type='checkbox']:checked + label > span:before {
        content: "";
        position: absolute;
        top: 6px;
        left: 4px;
        border-right: 3px solid transparent;
        border-bottom: 3px solid transparent;
        transform: rotate(45deg);
        transform-origin: 0% 100%;
        /* animation: checkbox-check 125ms 250ms cubic-bezier(.4,.0,.23,1) forwards;
        */
        width: 6px;
        height: 12px;
        border-color: #fff;
        transform: translate3d(0,-.5em,0) rotate(45deg);
    }
    /* input[type='checkbox'] + label:hover, input[type='checkbox']:focus + label {
        color: #333;
    } */
    input[type='checkbox'] + label:hover > span, input[type='checkbox']:focus + label > span {
        background: rgba(255,255,255,.1);
    }
    input[type='checkbox']:checked + label > ins {
        height: 100%;
    }
    input[type='checkbox']:checked + label > span {
        border: 10px solid #3490dc;
    }
    /* Radio Styles */
    input[type='radio'] + label{
        position: relative;
        display: flex;
        margin: 10px 0;
        /*align-items: center;*/
        font-weight: normal;
    }
    input[type='radio'] + label > ins{
        position: absolute;
        display: block;
        width: 100%;
        overflow: hidden;
        text-decoration: none;
    }
    input[type='radio'] + label > ins > i{
        position: absolute;
        bottom: 0;
        font-style: normal;
    }
    input[type='radio'] + label > span{
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
        width: 20px;
        height: 20px;
        background: transparent;
        border: 2px solid #333;
        -moz-border-radius: 50%;
        border-radius: 50%;
        cursor: pointer;
    }
        input[type='radio'] + label:hover, input[type='radio']:focus + label{
            color: #333;
        }
    input[type='radio'] + label:hover > span, input[type='radio']:focus + label > span{
        background: rgba(255,255,255,.1);
    }
    input[type='radio']:checked + label > ins{ height: 100%; }
    input[type='radio']:checked + label > span{
        border: 10px solid #3490dc;
    }
    input[type='radio']:checked + label > span:before{
        content: "";
        border-right: 6px solid #fff;
        border-radius: 50%;
        width: 6px;
        height: 6px;
        border-color: #fff;
        border-radius: 50%;
    }


    .handle {
        background: unset !important;
        border: unset !important;
        width: unset !important;
        height: unset !important;
    }

    .handle.handle-br {
        bottom: 0;
        right: 0;
        margin-bottom: -5px;
        z-index:50;
    }

    .handle.handle-br i {
        transform: rotate(45deg);
        font-size: 20px;
        width: 5px;
        height: 5px;
        z-index: 100000;
    }

    .handle, .vdr {
        position: absolute;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    .sidebar-options-selector {
        height: 250px;
        padding: 10px 0px 10px 30px;
        overflow-y: scroll;
    }

    .outline-none {
        outline: 0;
    }

    .lbl-toggle {
        display: block;
        cursor: pointer;
        transition: all 0.25s ease-out;
        margin: 0px;
    }

    .wrap-collabsible {
        margin-bottom: 1.2rem 0;
    }

    input[type='checkbox'] {
        display: none;
    }
    .collapsible-content {
        max-height: 0px;
        overflow: hidden;
        transition: max-height .25s ease-in-out;
    }

    .toggle:checked + .lbl-toggle + .collapsible-content {
        max-height: 1000px;
    }

    .toggle:checked + .lbl-toggle {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .collapsible-content .content-inner {

    }

</style>
